import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {Row, Col, Button, Tab, Modal, Form} from "react-bootstrap";
import {FaPlus, FaArrowLeft, FaTrash, FaPencilAlt, FaExclamationTriangle} from "react-icons/fa";
import swal from 'sweetalert';
import Loader from "./LoaderModal";
import Side from "./Sidebar";
import Top from "./Topbar";
import {Pagination, TableHeader, TableBody, Filter, useDatatableLifecycle, shouldTableUpdate} from 'react-bs-datatable';
import C from '../lib/Config';

const CustomTable = React.memo(props => {
    const { data, tableHeaders, onChangeFilter, onPageNavigate, classes, onSortChange, tableClass, labels, filterable, filterText, rowsPerPage, currentPage, sortedProp, maxPage, Components } = useDatatableLifecycle(props);
    return (
      <div>
        <Components.Row className="controlRow__root">
          <Components.Col xs="12">
            <Filter
              classes={classes}
              tableHeaders={tableHeaders}
              placeholder='Search by Protocol Name'
              onChangeFilter={onChangeFilter}
              filterText={filterText}
              filterable={filterable}
            />
          </Components.Col>
        </Components.Row>
        <Components.Row>
          <Components.Col xs="12">
            <Components.Table className={tableClass}>
              <TableHeader
                classes={classes}
                tableHeaders={tableHeaders}
                sortedProp={sortedProp}
                onSortChange={onSortChange}
                components={{
                  TableHead: Components.TableHead,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
              <TableBody
                classes={classes}
                tableHeaders={tableHeaders}
                labels={labels}
                data={data}
                components={{
                  TableBody: Components.TableBody,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
            </Components.Table>
          </Components.Col>
        </Components.Row>
        <Components.Row className="controlRow__root bottom">
          <Components.Col xs={12} md={12} className="text-right">
            <Pagination
              classes={classes}
              data={data}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              onPageNavigate={onPageNavigate}
              labels={labels}
              maxPage={maxPage}
              components={{ Button: Components.Button, ButtonGroup: Components.ButtonGroup }}
            />
          </Components.Col>
        </Components.Row>
      </div>
    );
  }, shouldTableUpdate);
export default class ProtocolMaster extends Component {
    constructor(props) {
        super(props)
        this.state = {
            protocolData: [],
            isModerator: false,
            isHospitalAdmin: false,
            userInstituteNames: [],
            showWarningModal: false,
            warningAcknowledged: false,
        };
       this.getAllProtocols = this.getAllProtocols.bind(this);
    }

    componentDidMount() {
        const userRole = localStorage.getItem('userRoleDto');
        let isHospitalAdmin = false;
        if (userRole) {
            const parsedUserRole = JSON.parse(userRole);
            if (parsedUserRole.roleName === 'Moderator') {
                this.setState({ isModerator: true });
            }
            if (parsedUserRole.roleName === 'Hospital Admin') {
                isHospitalAdmin = true;
                this.setState({ isHospitalAdmin: true });
            }
        }
        this.setState({ loaderModal: true });
        if (isHospitalAdmin) {
            // Load institutes first, then pass names directly into getAllProtocols to avoid state-timing issues
            this.getUserInstituteNames().then(names => {
                this.getAllProtocols(names);
                this.setState({ loaderModal: false });
            });
        } else {
            setTimeout(() => {
                this.getAllProtocols();
                this.setState({ loaderModal: false });
            }, 5000);
        }
    }

    getUserInstituteNames = () => {
        const userId = localStorage.getItem('userId');
        return fetch(`${C.getUrl()}/institute/getAllInstituteByUserId/${userId}`)
            .then(res => res.json())
            .then(res => {
                const data = Array.isArray(res) ? res : (res.message ? JSON.parse(res.message) : []);
                const names = data.map(d => d.instituteName);
                this.setState({ userInstituteNames: names });
                return names;
            })
            .catch(err => { console.error("Error fetching user institutes: " + err); return []; });
    }
    getAllProtocols(instituteNamesFilter) {
        return fetch(C.getUrl() + '/protocol/protocolDetails', {
            method: 'GET',
            mode: 'cors',
        })
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error && error !== 'undefined') {
                alert(error);
            } else {
                let obj = resObj.message;
            if (obj === 'No record found.') {
              
            } else {
                this.setState({ data: JSON.parse(resObj.message)})
                console.log(obj);
                  let tempData = JSON.parse(resObj.message);
                  const { isHospitalAdmin } = this.state;
                  const filterNames = instituteNamesFilter || this.state.userInstituteNames;
                  if (isHospitalAdmin) {
                      tempData = tempData.filter(obj =>
                          !obj.instituteName || filterNames.includes(obj.instituteName)
                      );
                  }
                  let protocolData = [];
                  let index = 1;
                  tempData.forEach(obj => {
                      let data = {
                        id : index,
                        protocolId : obj.protocolId,
                        name :  <Link to={{ pathname: '/ViewProtocol', search: 'p=' + obj.protocolId }}>{obj.protocolName}</Link>,
                        schedule : obj.scheduleName,
                        protocolType : obj.protocolType,
                        antiemeticRisk : obj.antiemeticRisk,
                        buttonOther : <FaTrash title='Delete Protocol' style={{color: "indianred"}} className="side-menu" onClick={() => this.deleteProtocol(obj.protocolId)}/>
                      }
                      protocolData.push(data);
                      index++;
                  });
                  //console.log(protocolData);
                  this.setState({ protocolData: protocolData });
                  //console.log(this.state.protocolData);
              }
            }
        })
        .catch(err => {
            console.log("Error : " + err);
        });
  }
  deleteProtocol(protocolId) {
    //console.log("protocolId : "+protocolId);
    swal({
      title: 'Are you sure?',
      text: "Once deleted you will not be able to recover this protocol.",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: "Yes",
      closeOnConfirm: false,
      buttons: true,
      buttons: ["No", "Yes"]
    }).then((isConfirm) => {
      if (isConfirm) {
        let loggedInuser = localStorage.getItem("userId");
        return fetch(C.getUrl() + '/protocol/inactivateProtocol?protocolId=' + protocolId + '&updatedById=' + loggedInuser, {
          method: 'GET',
          mode: 'cors',
        })
          .then(res => res.json())
          .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error && error !== 'undefined') {
              swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
            } else {
              let obj = resObj.message;
              if (resObj.statusCode == 200) {
                this.setState({ saveLoader: true });
                setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                swal({ title: obj, icon: "success", buttons: false, timer: 10000, });
                window.location.reload();
              } else {
                setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                swal({ title: obj, icon: "success", buttons: false, timer: 10000, });
              }
            }
          })
          .catch(err => {
            console.log("Error : " + err);
          });
      }
    });
      
    }
    render() {
        const header = [{title: '#', prop: 'id'},{title: 'Protocol Name', prop: 'name', sortable: true, filterable: true},{title: 'Schedule', prop: 'schedule', sortable: true},
        {title: 'Protocol Type', prop: 'protocolType', sortable: true},{title: 'Antiemetic Risk', prop: 'antiemeticRisk', sortable: true},{title: '', prop: 'buttonOther'}];
        const customLabels = {show: 'Display', entries: 'rows', noResults: 'No records found'};
        const classes = {table: 'table-striped table-striped table-hover text-nowrap dataTable mt-4', thead: 'thead-light'};
        
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <div className="container-fluid">
                            <div className="app-content">
                                <section className="section">
                                    <div className="row">
                                        <Col lg='12'>
                                            <Tab.Container>
                                                <Row>
                                                    <Col lg='12'>
                                                        <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                            <div className="card-header flex-wrap"> 
                                                                <h3 className="fs-18 mb-4 header_title text-black"><Link to="/Dashboard" className="btn mr-2 btn-light"><FaArrowLeft className='fs-18' size='2.0rem' style={{verticalAlign: 'baseline'}}/> </Link>  Protocol Master</h3> 
                                                                {this.state.isModerator && (
                                                                <Link to="/AddProtocol">
                                                                    <Button variant="secondary" className="float-right btn-primary" >
                                                                        <FaPlus className='mr-2' style={{verticalAlign: "text-top"}} />New Protocol
                                                                    </Button>
                                                                </Link>
                                                                )}
                                                                {this.state.isHospitalAdmin && (
                                                                <Button variant="secondary" className="float-right btn-primary" onClick={() => this.setState({ showWarningModal: true, warningAcknowledged: false })}>
                                                                    <FaPlus className='mr-2' style={{verticalAlign: "text-top"}} />New Protocol
                                                                </Button>
                                                                )}
                                                            </div>
                                                            <div className="card-body p-3">
                                                                <Row className="mb-3"> </Row>
                                                                <Row>
                                                                    <Col lg='12'>
                                                                        <CustomTable
                                                                            id="datatableProtocolList"
                                                                            tableHeaders={header}
                                                                            tableBody={this.state.protocolData} 
                                                                            rowsPerPage={10}
                                                                            initialSort={{ prop: 'id', isAscending: true }}
                                                                            labels={customLabels}
                                                                            classes={classes}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                        </Col>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <Loader show={this.state.loaderModal} />
                    </div>
                </div>

                <Modal show={this.state.showWarningModal} centered size="lg" backdrop="static" keyboard={false}>
                    <Modal.Header style={{backgroundColor: '#fff8e1', borderBottom: '2px solid #ffcc02', padding: '1.2rem 1.5rem'}}>
                        <Modal.Title style={{color: '#bf360c', fontWeight: 700, fontSize: '1.4rem', letterSpacing: '0.01em'}}>
                            <FaExclamationTriangle className='mr-2' style={{verticalAlign: 'middle', color: '#f57c00', fontSize: '1.3rem'}} />
                            Non-Standard Protocol Configuration Notice
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{padding: '1.5rem 1.8rem', fontSize: '14px', lineHeight: '1.7', color: '#212121'}}>
                        {(() => {
                            const instituteName = this.state.userInstituteNames[0] || 'your institution';
                            return (
                                <>
                                    <p className='mb-3' style={{fontSize: '14px'}}>
                                        You are about to configure a <strong>{instituteName}</strong> specific protocol that deviates from the standard oncology protocols established by the Global Standard Clinical Practice Guidelines.
                                    </p>
                                    <p className='mb-2' style={{fontSize: '14px', fontWeight: 600, color: '#37474f'}}>
                                        By proceeding, {instituteName} acknowledges and accepts that:
                                    </p>
                                    <ul style={{listStyleType: 'disc', paddingLeft: '1.5rem', marginBottom: '1.2rem', fontSize: '14px'}}>
                                        <li style={{marginBottom: '0.55rem'}}>This protocol has not been validated against national/international oncology standards.</li>
                                        <li style={{marginBottom: '0.55rem'}}>Clinical decisions made under this protocol are the sole responsibility of <strong>{instituteName}</strong>.</li>
                                        <li style={{marginBottom: '0.55rem'}}>The oncology platform provider bears no medico-legal liability for treatment outcomes, adverse events, or deviations from evidence-based care resulting from this configuration.</li>
                                        <li style={{marginBottom: '0.55rem'}}>It is <strong>{instituteName}</strong>'s responsibility to ensure this protocol has been reviewed and approved by a qualified clinical authority before use.</li>
                                    </ul>
                                    <p style={{fontSize: '13px', color: '#e65100', fontStyle: 'italic', marginBottom: '1.2rem'}}>
                                        &#9432;&nbsp; This action will be logged and attributed to {instituteName}.
                                    </p>
                                    <div style={{backgroundColor: '#f5f5f5', border: '1px solid #e0e0e0', borderRadius: '6px', padding: '1rem 1.2rem'}}>
                                        <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
                                            <input
                                                type='checkbox'
                                                id='warning-acknowledge-checkbox'
                                                checked={this.state.warningAcknowledged}
                                                onChange={e => this.setState({ warningAcknowledged: e.target.checked })}
                                                style={{marginTop: '3px', flexShrink: 0, width: '16px', height: '16px', cursor: 'pointer'}}
                                            />
                                            <label htmlFor='warning-acknowledge-checkbox' style={{margin: 0, fontWeight: 600, fontSize: '14px', color: '#1a237e', cursor: 'pointer', lineHeight: '1.6'}}>
                                                I confirm that this non-standard protocol has been reviewed and approved by <strong style={{color: 'inherit'}}>{instituteName}</strong>'s clinical authority, and <strong style={{color: 'inherit'}}>{instituteName}</strong> accepts full ownership of its use and outcomes.
                                            </label>
                                        </div>
                                    </div>
                                </>
                            );
                        })()}
                    </Modal.Body>
                    <Modal.Footer style={{borderTop: '1px solid #e0e0e0', padding: '1rem 1.5rem'}}>
                        <Button variant='outline-secondary' style={{minWidth: '90px'}} onClick={() => this.setState({ showWarningModal: false, warningAcknowledged: false })}>
                            Cancel
                        </Button>
                        <Button
                            style={{minWidth: '200px', backgroundColor: this.state.warningAcknowledged ? '#e65100' : '#bdbdbd', borderColor: this.state.warningAcknowledged ? '#e65100' : '#bdbdbd', color: '#fff', fontWeight: 600}}
                            disabled={!this.state.warningAcknowledged}
                            onClick={() => { this.setState({ showWarningModal: false }); this.props.history.push('/AddProtocol'); }}
                        >
                            I Acknowledge &amp; Proceed
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
